import React from 'react';
import MenuIcon from '@mui/icons-material/Menu';
import CloseIcon from '@mui/icons-material/Close';

import { MobileMenuButtonContainer } from './styles';

const MobileMenuButton = ({ isMobileMenuOpened, mobileIconClicked }) => (
  <MobileMenuButtonContainer data-testid="mobile-menu-button">
    {isMobileMenuOpened ? (
      <CloseIcon className="mobile-menu--close-icon" onClick={mobileIconClicked} />
    ) : (
      <MenuIcon className="mobile-menu--burger-icon" onClick={mobileIconClicked} />
    )}
  </MobileMenuButtonContainer>
);

export default MobileMenuButton;
